"use client";

import {Block} from "@/lib/interfaces/blocks";
import {Page, Sidebar as SidebarInterface} from "@/lib/interfaces/pages";
import React, {useCallback, useEffect, useRef} from "react";
import BlockGeneratedSideNav from "@/components/BlockGeneratedSideNav";
import Sidebar from "@/components/Sidebar";
import BlockResolver from "@/components/BlockResolver";

interface PageContainerProps {
    page?: Page
    showSidebar: boolean
    children?: React.ReactNode
    blocks: Block[]
    sidebar?: SidebarInterface|null
    className?: string
}

export default function PageContainer({page, showSidebar, blocks, sidebar, children, className}: PageContainerProps) {
    const ref = useRef<any>(null);

    const handleScrollEvent = useCallback((event: any) => {
        const container = ref.current;

        if (container) {
            const navPageItems = container.querySelectorAll('.navPage-item');
            const navPageSections = container.querySelectorAll('.block-section');
            const currentScrollPosition = window.pageYOffset;
            navPageSections.forEach((section: any) => {
                const sectionId = section.getAttribute('id');
                const currentViewport = section.getBoundingClientRect();
                const sectionTop = currentViewport.top + window.scrollY;
                if (currentScrollPosition >= sectionTop - 100 && currentScrollPosition < sectionTop + 100) {
                    const NavPageItemTarget = container.querySelector(`.navPage-item[data-scrollto="${sectionId}"]`);
                    navPageItems.forEach((item: any) => {
                        item.classList.remove('m-selected');
                    });
                    if (NavPageItemTarget) {
                        NavPageItemTarget.classList.add('m-selected');
                    }
                    // if (sectionId === "top") {
                    //     history.pushState(null, null, window.location.pathname);
                    // } else {
                    //     history.pushState(null, null, `#${sectionId}`);
                    // }
                }
            });
        }
    }, []);
    useEffect(() => {

        const container = ref.current;
        const firstNavpageItem = container.querySelector('.eo-navPage .navPage-item');
        if (firstNavpageItem) {
            firstNavpageItem.classList.add('m-selected');
        }

        window.addEventListener("load", handleScrollEvent);
        window.addEventListener("scroll", handleScrollEvent);
        return () => {
            window.removeEventListener("load", handleScrollEvent);
            window.removeEventListener("scroll", handleScrollEvent);
        }

        // const container = ref.current;
        // const blocks = container.querySelectorAll('.block-section');
        // blocks.forEach((block) => {
        //     const observer = new IntersectionObserver(
        //         ([entry]) => {
        //             const blockId = entry.target.id;
        //             const sidebarNavItem = container.querySelector(`.navPage-item[data-scrollto="${blockId}"]`);
        //             if (sidebarNavItem) {
        //                 if (entry.isIntersecting) {
        //                     sidebarNavItem.classList.add('m-selected');
        //                 } else {
        //                     sidebarNavItem.classList.remove('m-selected');
        //                 }
        //             }
        //         }, {threshold: 0.2}
        //     );
        //     observer.observe(block);
        //     return () => observer.disconnect();
        // });
    });
    return (
        <div className={`main-content ${className ?? ''}`} ref={ref}>
            <div className="content-main">
                {children ?? ''}
                <BlockResolver parent={page} blocks={blocks}/>
            </div>
            {showSidebar &&
                <div className="content-side">
                    {sidebar ?
                        <Sidebar sidebar={sidebar} />
                        :
                        <BlockGeneratedSideNav blocks={blocks} containerRef={ref} />
                    }
                </div>
            }
        </div>
    )
}
